<template>
  <div id="containerPurchaseDetailsPage">
    <div id="containerDatePickers">
      <label
        class="my-label text-xs-center"
      >What timeframe do you have to find a home in?</label>
      <div>
        <v-container class="no-padding">
          <div class="modal-send-message__text">
            PRICE RANGE
            <div class="inform-container">
              <span>
                Min <input
                  v-model="priceMin"
                  v-money="money"
                  type="text"
                ></span>
              <span class="price-max-input">
                Max <input
                  v-model="priceMax"
                  v-money="money"
                  type="text"
                ></span>
            </div>
            <div v-if="!clientData.goalDate">
              GOAL DATE
              <br>
              <v-menu
                ref="datePicker"
                v-model="data.dataPicker"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="dateFormatted" readonly v-on="on" />
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer />
                  <v-btn flat color="primary" @click="data.dataPicker = false">
                    Cancel
                  </v-btn>
                  <v-btn flat color="primary" @click="updateDateToDatePicker">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
          <!-- <v-layout align-center justify-center> -->
          <!-- <v-flex shrink>
            <label>Goal date</label>
          </v-flex>
          <v-flex xs4 class="no-padding">
            <v-menu
              v-model="menuFrom"
              class="menu-date-picker"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              nudge-bottom="5px"
              max-width="250px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dateFromFormatted" color="purple" readonly v-on="on" />
              </template>
              <v-date-picker
                v-model="goalDate"
                color="purple"
                no-title
                full-width
                scrollable
                show-current="false"
              />
            </v-menu>
          </v-flex>
          <v-flex shrink>
            <v-icon :color="$btnHwayzBlue">
              calendar_today
            </v-icon>
          </v-flex>
          </v-layout> -->
        </v-container>
      </div>
    </div>
    <!-- <div class="containerBuyOrRent">
      <label class="my-label text-xs-center">Are you looking to buy or rent a home?</label>
      <v-container>
        <v-layout justify-center>
          <v-flex shrink class="text-xs-right container-checkbox">
            <label class="container-form-checkbox">
              Buy
              <input v-model="buy" type="checkbox">
              <span class="form-checkmark" />
            </label>
          </v-flex>
          <v-flex shrink class="container-checkbox">
            <label class="container-form-checkbox">
              Rent
              <input v-model="rent" type="checkbox">
              <span class="form-checkmark" />
            </label>
          </v-flex>
        </v-layout>
      </v-container>
    </div> -->
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import { mapState } from 'vuex'

export default {
  directives: { money: VMoney },
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      date: null,
      dateFormatted: '',
      data: {
        dataPicker: false
      },
      priceMin: null,
      priceMax: null,
      goalDate: undefined,
      buy: true,
      money: {
        decimal: ',',
        thousands: ',',
        prefix: '$',
        precision: 0
      },
      rent: false,
      weekdays: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
    }
  },
  computed: {
    ...mapState('client', ['clientData']),

    dateFromFormatted() {
      return this.formatDate(this.goalDate)
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}-${day}-${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    updateDateToDatePicker() {
      this.goalDate = this.parseDate(this.dateFormatted)
      this.data.dataPicker = false
    },
    weekdayFn() {
      return this.weekdays[++this.counter % 7]
    },
    submit() {
      this.normalizePrice()
      return this.$emit('submit', {
        goalDate: this.goalDate,
        priceMin: this.priceMin,
        priceMax: this.priceMax
      })
    },
    normalizePrice() {
      this.priceMin = parseInt(this.priceMin.replace(/[,$]/g, ''))
      this.priceMax = parseInt(this.priceMax.replace(/[,$]/g, ''))
    }
  }
}
</script>

<style scoped lang="sass">
*:focus
  outline: none

#containerPurchaseDetailsPage
  height: 100%
  width: 100%
  margin: 0 auto

#containerDatePickers
  text-align: left
  margin: 0% 14%
  font-size: $hwayzFont0em8
  padding-bottom: 15%

.my-label
  display: block
  font-size: $hwayzFont1rem4
  margin-bottom: 10px !important

.v-menu__content
  border-radius: 10px !important
  box-shadow: 0px 0px 2px 0px gray

.v-picker >>> .v-btn--active
  color: white !important

.v-picker >>> th
  font-weight: 300
  border-bottom: 1px solid lightgray

.v-text-field >>> input[type=text]
  padding: 0 !important
  text-align: center

.no-padding
  padding: 0 !important

/* Custom checkbox style */
/* Customize the label (the container) */
.container-checkbox
  width: fit-content
  /* padding: 20px; */

.container-form-checkbox
  display: block
  position: relative
  padding-left: 25px
  cursor: pointer
  font-size: $hwayzFont1rem4
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
  user-select: none

/* Hide the browser's default checkbox */
.container-form-checkbox input
  position: absolute
  opacity: 0
  cursor: pointer
  height: 0
  width: 0

/* Create a custom checkbox */
.form-checkmark
  position: absolute
  top: 0
  left: 0
  height: 18px
  width: 18px
  -moz-box-shadow:    inset 0 2px 4px 0px lightgray
  -webkit-box-shadow: inset 0 2px 4px 0px lightgray
  box-shadow:         inset 0 2px 4px 0px lightgray

/* Create the form-checkmark/indicator (hidden when not checked) */
.form-checkmark:after
  content: ""
  position: absolute
  display: none

/* Show the form-checkmark when checked */
.container-form-checkbox input:checked ~ .form-checkmark:after
  display: block

/* Style the form-checkmark/indicator */
.container-form-checkbox .form-checkmark:after
  left: 6px
  top: 2px
  width: 5px
  height: 12px
  border: solid $hwayzTeal
  border-width: 0 2px 2px 0
  -webkit-transform: rotate(40deg)
  -ms-transform: rotate(40deg)
  transform: rotate(40deg)

.modal-send-message__text
  display: flex
  flex-direction: column
  text-align: left
  padding: 0 2rem
  margin-top: 2rem
  font-weight: 500
  font-size: 1.1rem !important
.modal-send-message__text span
  color: $hwayzMediumGray
  font-size: 1.2rem
.inform-container
  display: flex
  flex-direction: row
  justify-content: space-between
  margin: 0.5rem 0 3rem
.modal-content
  padding: 2rem
  display: inline-block
  .modal-button
    width: 95%
    border-radius: 5px
    color: $hwayzWhite
    font-weight: 500 !important
    font-size: 1.2rem !important
  .cancel
    border: 1px solid $hwayzDarkGray !important
    color: $hwayzBlack
input[type=text], .v-text-field
  border: 1px solid $hwayzLightGray
  height: 35px
  width: 150px
  vertical-align: middle
  font-size: 1.2rem
input[type=text]
  padding-left: 20px
  color: $hwayzBlack
.price-max-input
  margin-left: 10px
input[type=text]:focus::-webkit-input-placeholder
  color: transparent
input[type=text]::-webkit-inner-spin-button,
input[type=text]::-webkit-outer-spin-button
  -webkit-appearance: none
  margin: 0
.v-text-field
  padding: 0 2rem !important
  font-weight: 350
</style>
